<template>
  <div class="card">
    <div class="card-header"><i class="icon-refresh"></i> Filtrer</div>
    <div class="card-block">
      <div class="row">
        <div class="col-sm-4 form-group">
          <label>Date de</label>
          <v-select
            v-model="filters.dateKey"
            :options="dateKeyOptions"
            :reduce="({ value }) => value"
          ></v-select>
        </div>
        <div class="col-sm-4 form-group">
          <label>Entre le</label>
          <Datepicker
            v-model="filters.begin"
            format="dd.MM.yyyy"
            language="fr"
            input-class="form-control"
          ></Datepicker>
        </div>
        <div class="col-sm-4 form-group">
          <label>et le</label>
          <Datepicker
            v-model="filters.end"
            format="dd.MM.yyyy"
            language="fr"
            input-class="form-control"
          ></Datepicker>
        </div>
        <div class="col-sm-6 form-group">
          <label>Commercial (B2C)</label>
          <Multiselect
            v-model="filters.b2cCommercials"
            placeholder="Sélectionner un ou plusieurs commerciaux"
            :options="b2cCommercialsOptions"
            :multiple="true"
            label="label"
            track-by="label"
            class="custom-multiselect"
          >
          </Multiselect>
        </div>
        <div class="col-sm-6 form-group">
          <label>Commercial (B2B)</label>
          <Multiselect
            v-model="filters.b2bCommercials"
            placeholder="Sélectionner un ou plusieurs commerciaux"
            :options="b2bCommercialsOptions"
            :multiple="true"
            label="label"
            track-by="label"
            class="custom-multiselect"
          >
          </Multiselect>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <button
        type="button"
        class="btn btn-sm btn-secondary"
        @click="applyFilters"
      >
        <i class="icon-eye"></i>&nbsp; Visualiser
      </button>
    </div>
  </div>
</template>

<script>
import moment from "moment";

import Multiselect from "vue-multiselect";
import Datepicker from "vuejs-datepicker";

export default {
  components: {
    Multiselect,
    Datepicker,
  },

  data() {
    return {
      filters: {
        dateKey: "createdAt",
        begin: moment().startOf("month").toDate(),
        end: moment().endOf("month").toDate(),
        b2cCommercials: [],
        b2bCommercials: [],
      },

      dateKeyOptions: [
        { label: "Création de la fiche", value: "createdAt" },
        { label: "Dernière modification", value: "updatedAt" },
        { label: "Envoi d'email Linkedin", value: "linkedinEmailSentAt" },
        { label: "Envoi lead B2B", value: "leadSentToB2bCommercialAt" },
        { label: "Prise de contact lead B2B", value: "contactedAt" },
        { label: "Audit", value: "auditAt" },
        { label: "Vente", value: "saleAt" },
      ],
      commercials: [],
    };
  },

  computed: {
    b2cCommercialsOptions() {
      return this.commercials
        .filter((c) => c.commercial?.isB2C)
        .map((c) => ({
          value: c.email,
          label: c.commercial?.pseudo || c.firstName,
        }));
    },

    b2bCommercialsOptions() {
      return this.commercials
        .filter((c) => c.commercial?.isB2B)
        .map((c) => ({
          value: c.email,
          label: c.commercial?.pseudo || c.firstName,
        }));
    },
  },

  mounted() {
    this.fetchCommercials();
  },

  methods: {
    applyFilters() {
      this.$emit("apply", {
        ...this.filters,
        b2cCommercials: this.filters.b2cCommercials.map((c) => c.value),
        b2bCommercials: this.filters.b2bCommercials.map((c) => c.value),
      });
    },

    async fetchCommercials() {
      try {
        const { data } = await this.$api.get("/users/commercials/search");

        this.commercials = data;

        if (this.$store.state.user.commercial?.isCommercial) {
          const currentCommercial = this.commercials.find(
            (c) => c.email === this.$store.state.user.email,
          );

          if (currentCommercial?.commercial?.isB2C) {
            this.filters.b2cCommercials = [
              {
                label:
                  currentCommercial.commercial.pseudo ||
                  currentCommercial.firstName,
                value: currentCommercial.email,
              },
            ];
          }

          if (currentCommercial?.commercial?.isB2B) {
            this.filters.b2bCommercials = [
              {
                label:
                  currentCommercial.commercial.pseudo ||
                  currentCommercial.firstName,
                value: currentCommercial.email,
              },
            ];
          }
        }
      } catch (e) {
        this.commercials = [];
      }
    },
  },
};
</script>
